import { enumToNameWithDefault } from '@ps-smart-cp/ppfw-client';
import { importClassNameConfig } from './ImportClass.name';

enum ImportClass {
  /** 全件洗い替え */
  replace = 'REPLACE',
  /** データの追加 */
  insert = 'INSERT',
  /** データの追加更新 */
  update = 'UPDATE',
}

const importClassToDisplay = enumToNameWithDefault(ImportClass, importClassNameConfig);

export { ImportClass, importClassToDisplay };
